<nav>
  <!-- <button class="guided-tour-btn" [class]="guidedTourService.isActive() ? 'active' : ''"
    (click)="guidedTourService.toogle()" (mouseenter)="guidedTourHover.set(true)"
    (mouseleave)="guidedTourHover.set(false)">
    <kin-icon name="guided_tour"
      [color]=" (guidedTourHover() && !guidedTourService.active()) ? colorService.backgroundColor() : colorService.textColor()" />
    <p>{{'visite guidée' | upperFirstLetter }}</p>
  </button> -->
  <!-- <button class="notifications-btn" #notificationsMenu (click)="toggleNotificationsMenuState()">
    <kin-icon name="bell_stroke" [color]="colorService.textColor()" />
  </button> -->

  <app-notification-dropdown
    class="nav-bar-notifications-menu-dropdown"
    appDropdown
    [state]="notificationsMenustate()"
    (stateChange)="onNotificationsMenuStateChange($event)"
  />

  <button class="profile-btn" #userMenu (click)="toggleUserMenuState()">
    @if (!profileRessources.isLoading()) {
      <img [src]="profileRessources.value().avatar_url" alt="" />
    } @else if (profileRessources.error()) {
      <p>ERROR</p>
    } @else {
      <kin-skeleton shape="circle" [height]="48" [width]="48" unit="px" />
    }
    <kin-icon name="arrow_bottom" [size]="16" [color]="colorService.textColor()" />
  </button>
  <ul
    class="nav-bar-user-menu-dropdown"
    appDropdown
    [state]="userMenustate()"
    (stateChange)="onUserMenuStateChange($event)"
  >
    <li class="user-info">
      @if (!profileRessources.isLoading()) {
        <p>{{ profileRessources.value().fullname }}</p>
        <span class="roles">{{ clientRoles() }}</span>
      } @else if (profileRessources.error()) {
        <p>ERROR</p>
      } @else {
        <kin-skeleton [height]="20" [width]="90" unit="px" />
        <kin-skeleton [height]="20" [width]="120" unit="px" />
      }
    </li>
    <span class="divider"></span>
    <li>
      <button (click)="toggleUserMenuState()">
        {{ 'nav_bar.user_menu.switch_account' | translate }}
      </button>
    </li>
    @if (analyticsService.enabled) {
      <li>
        <button (click)="toggleUserMenuState()" (click)="analyticsService.reviewConsent()">
          {{ 'nav_bar.user_menu.cookies' | translate }}
        </button>
      </li>
    }
    <li>
      <button (click)="toggleUserMenuState()" (click)="loginService.logout()">
        {{ 'common.logout' | translate }}
      </button>
    </li>
  </ul>
</nav>
